import { Dictionary, pickBy } from 'lodash';

export function removeEmptyOrUndefinedValues<T extends Dictionary<string>>(
  obj: T,
) {
  return pickBy<T>(obj, (value) => value !== '' && value !== undefined);
}
